/**
 * Shared Category Icon Map (Story 5.37)
 *
 * Maps PAGE_CATEGORIES iconName strings to Phosphor icon components.
 * Single source of truth — imported by PageCategoryGroup, PageListItem, and PageSelectorSidebar.
 */

import {
  SquaresFour,
  Users,
  CursorClick,
  ChartLineUp,
  Target,
  CurrencyDollar,
  MagnifyingGlass,
  ShareNetwork,
  EnvelopeSimple,
  Phone,
  Notebook,
} from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";

export const CATEGORY_ICON_MAP: Record<string, Icon> = {
  SquaresFour,
  Users,
  CursorClick,
  ChartLineUp,
  Target,
  CurrencyDollar,
  MagnifyingGlass,
  ShareNetwork,
  EnvelopeSimple,
  Phone,
  Notebook,
};
